export function Logo() {
  return (
    <svg
      className="super-logo"
      width="32"
      height="32"
      viewBox="0 0 40 40"
      role="img"
      aria-label="SUPER TODO Logo"
    >
      <rect width="40" height="40" rx="11" fill="#b5ed64" />
      <path
        d="M28 11H16a6 6 0 0 0 0 12h8a3 3 0 0 1 0 6H12"
        fill="none"
        stroke="#172114"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="m24 15 4 4 7-8"
        fill="none"
        stroke="#172114"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
